import { IReferralsPageParams } from "shared/pages/ReferralsPage";

import { IState } from "..";
import FirebaseFunctionsService from "../../../services/firebase/functions/FirebaseFunctionsService";
import RavenService from "../../../services/Logging/RavenService";
import UrlUtils from "../../../services/utils/UrlUtils";
import { Dispatch } from "../../store/store";

export const referWithProps = async (
  params: IReferralsPageParams,
  state: IState
) => {
  try {
    Dispatch.referrals.creatingMemberApplication();
    const response = await FirebaseFunctionsService.createInvoice(params);
    console.log(response);
    if (response.ok && response.data) {
      const { redirectLink } = response.data;
      const referralPath = UrlUtils.urlPath(redirectLink);
      Dispatch.referrals.createMemberApplicationSuccess({
        referralPath
      });
    } else {
      Dispatch.referrals.createMemberApplicationFailure({
        error: JSON.stringify(response)
      });
    }
  } catch (error) {
    console.error(error);
    Dispatch.referrals.createMemberApplicationFailure({
      error: JSON.stringify(error)
    });
    RavenService.captureException(error, JSON.stringify(params));
  }
};



// WEBPACK FOOTER //
// ./src/state/modules/referrals/ReferralsEffetcs.ts